// components/RepliesPage/index.tsx
import RepliesPageContainer from "./RepliesPageContainer";

interface RepliesPageProps {
  personaId: string;
  personaData: any;
}

export default function RepliesPage({
  personaId,
  personaData,
}: RepliesPageProps) {
  return (
    <RepliesPageContainer personaId={personaId} personaData={personaData} />
  );
}
